import { render, staticRenderFns } from "./accordion-hotel-standard.vue?vue&type=template&id=4adfafb8"
import script from "./accordion-hotel-standard.js?vue&type=script&lang=js&external"
export * from "./accordion-hotel-standard.js?vue&type=script&lang=js&external"
import style0 from "./accordion-hotel-standard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports